import { Text } from '@dixa/lib-shared-habla';

import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type OrderFulfilledProps = {
  entry: UserAuditLogEntry<'COMMERCE_ORDER_FULFILLED'>;
};

export const OrderFulfilled = ({ entry }: OrderFulfilledProps): JSX.Element => {
  // Prefer the carrier tracking number over the internal fulfillment id -
  // it's what agents can actually act on. Falls back to the fulfillment id
  // when no tracking number was reported.
  const trackingValue = entry.tracking_number ?? entry.fulfillment_id;
  const trackingLabel = entry.tracking_number
    ? 'Tracking reference'
    : 'Fulfillment ID';
  // stopPropagation keeps a click on the link from also toggling the card.
  const trackingContent =
    trackingValue && entry.tracking_url ? (
      <Text.ExternalLink
        href={entry.tracking_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => event.stopPropagation()}
      >
        {trackingValue}
      </Text.ExternalLink>
    ) : (
      trackingValue
    );

  return (
    <UserActivityCard
      entry={entry}
      icon="check-circle"
      color={statusColors.positive}
      title="Order fulfilled"
      summary={
        <SummaryItems
          items={[
            {
              key: 'order',
              content: entry.order_id,
              copyText: entry.order_id,
              label: 'Order ID',
            },
            {
              key: 'fulfillment',
              content: trackingContent,
              copyText: trackingValue,
              label: trackingLabel,
            },
          ]}
        />
      }
    >
      {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
    </UserActivityCard>
  );
};
